import React from 'react';
import PropTypes from 'prop-types';
import ComplaintPositionTableRow from './ComplaintPositionTableRow';
import ResponsiveTable from '../base/Table/ResponsiveTable';
import EmptyRow from '../base/Table/EmptyRow';

const ComplaintPositionsTable = ({complaintPositions, onDeletePositionBtnClick, onEditPositionBtnClick}) => {
    return(
        <ResponsiveTable
            htmlId="complaintPositionsList">
            <thead>
                <tr>
                    <th className="col-xs-2">Pozycja</th>
                    <th className="col-xs-2">Indeks</th>
                    <th className="col-xs-2">Element</th>
                    <th className="col-xs-4">Opis wady</th>
                    <th className="col-xs-1">Edytuj</th>
                    <th className="col-xs-1">Usuń</th>
                </tr>
            </thead>
            <tbody>
                {complaintPositions.length===0 && 
                    <EmptyRow
                        columnNumbers={5}
                        text="Brak pozycji zgłoszenia" /> }
                {complaintPositions.map(complaintPosition =>
                    <ComplaintPositionTableRow
                        complaintPosition={complaintPosition}
                        key={complaintPosition.id}
                        onDeletePositionBtnClick={onDeletePositionBtnClick}
                        onEditPositionBtnClick={onEditPositionBtnClick} />
                )}
            </tbody>
        </ResponsiveTable>
    );
};

ComplaintPositionsTable.propTypes = {
    complaintPositions: PropTypes.array,
    onDeletePositionBtnClick: PropTypes.func,
    onEditPositionBtnClick: PropTypes.func
};

export default ComplaintPositionsTable;


// WEBPACK FOOTER //
// ./src/components/ComplaintPositions/ComplaintPositionsTable.js